'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    CrowdEstimationWidgetController.$inject = ['$q', '$translate', 'peopleService'];
    angular.module('app.iot').component('crowdEstimationWidget', {
        template: '<div class="panel dashboard-panel {{$ctrl.cssClass}}" translate-namespace="people"><div class="panel-heading"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h2><span translate>.Crowd Estimation</span><span class="header-date">{{$ctrl.currentDate}}</span></h2></div></div></div><div class="panel-heading" style="padding-top: 0; padding-bottom: 0;"><div class="row"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7"><h3 translate>.Zone</h3></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5"><div class="panel-heading-controls"><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span><select class="form-control input-sm" ng-model="$ctrl.selectedZone" ng-options="o[$ctrl.translations[\'scanner.name\']] for o in $ctrl.scanners" ng-change="$ctrl.onScannerChange()"></select></div></div></div></div></div><div class="panel-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><nvd3 class="nvd3-chart" config="$ctrl.uiConfig.lineChart.config" options="$ctrl.uiConfig.lineChart.options" data="$ctrl.peopleCharts[$ctrl.selectedZone.scanner_id]"></nvd3></div></div></div><div class="panel-footer"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="text-right"><a href="https://people.smartcity.heraklion.gr/" target="_blank"><span translate>.see more</span></a></div></div></div></div></div>',
        controller: CrowdEstimationWidgetController,
        controllerAs: '$ctrl',
        bindings: {
            cssClass: '@',
            lineColor: '@'
        }
    });

    function CrowdEstimationWidgetController($q, $translate, peopleService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        /**
         * 
         */
        $ctrl.$onInit = function () {

            $ctrl.uiConfig = new UiConfig();
            $ctrl.currentDate = d3.time.format('%d/%m/%Y')(new Date());
            $q.all({
                groupedData: peopleService.getGroupedData(),
                scanners: peopleService.getScanners(),
                translations: getTranslations()
            }).then(function (result) {
                $ctrl.translations = result.translations;
                $ctrl.scanners = result.scanners;
                $ctrl.peopleCharts = [];

                setTranslations($ctrl.translations);

                result.groupedData.map(function (value, key) {
                    $ctrl.peopleCharts[key] = [{
                        key: [key],
                        color: $ctrl.lineColor ? $ctrl.lineColor : '#fff',
                        values: value || [],
                        min: _.minBy(value, 'total'),
                        max: _.maxBy(value, 'total')
                    }];
                });
                $ctrl.uiConfig.setTranslations($ctrl.translations);

                $ctrl.onScannerChange();
            });
        };

        /**
         * 
         */
        $ctrl.onScannerChange = function () {
            if (!$ctrl.selectedZone) {
                $ctrl.selectedZone = $ctrl.scanners[0];
            }

            var chart = $ctrl.peopleCharts[$ctrl.selectedZone.scanner_id];

            var min = _.get(chart, '0.min.total', undefined),
                max = _.get(chart, '0.max.total', undefined);

            $ctrl.uiConfig.lineChart.options.chart.forceY = [];

            if (min) {
                $ctrl.uiConfig.lineChart.options.chart.forceY.push(min - Math.round(min * 0.1));
            }
            if (max) {
                $ctrl.uiConfig.lineChart.options.chart.forceY.push(max + Math.round(max * 0.1));
            }
        };

        /**
         * 
         */
        function getTranslations() {
            return $translate(['scanner.name', 'people.unit']);
        }

        function setTranslations(i18n) {}

        $ctrl.$onChanges = function (changesObj) {};
        $ctrl.$onDestroy = function () {};

        var UiConfig = function () {
            function UiConfig(form, measurementsService) {
                _classCallCheck(this, UiConfig);

                this.lineChart = new LineChartConfig(form, measurementsService);
            }

            _createClass(UiConfig, [{
                key: 'setTranslations',
                value: function setTranslations(i18n) {
                    this.lineChart.setTranslations(i18n);
                }
            }]);

            return UiConfig;
        }();

        var LineChartConfig = function () {
            function LineChartConfig() {
                _classCallCheck(this, LineChartConfig);

                this.config = {
                    deepWatchOptions: true,
                    deepWatchData: true,
                    deepWatchDataDepth: 1,
                    debounce: 100
                };
                this.options = {
                    title: { enable: false },
                    subtitle: { enable: false },

                    chart: {
                        type: 'lineWithFocusChart',

                        useInteractiveGuideline: true,

                        height: 170,
                        duration: 300,
                        showLegend: false,
                        focusEnable: true,

                        margin: { top: 20, right: 20, bottom: 20, left: 20 },

                        focus: {
                            height: 0
                        },

                        interpolate: 'cardinal',

                        defined: function defined(d, i) {
                            return d.total !== null;
                        },

                        x: function x(d) {
                            return d.at;
                        },
                        y: function y(d) {
                            return d.total;
                        },

                        xScale: d3.time.scale(),

                        xAxis: {
                            tickFormat: d3.currentLocale.timeFormat.multi([['%H:%M', function (d) {
                                return d.getHours();
                            }], ['%a %d', function (d) {
                                return d.getDay() && d.getDate() != 1;
                            }], ['%a %d', function (d) {
                                return d.getDate() != 1;
                            }], ['%a %d', function (d) {
                                return d.getMonth();
                            }], ['%a %d', function (d) {
                                return true;
                            }]])
                        },
                        yAxis: { tickFormat: d3.format(',.0f') },

                        interactiveLayer: {
                            tooltip: {
                                headerFormatter: d3.currentLocale.timeFormat.multi([['%d/%m/%Y %H:%M', function (d) {
                                    return true;
                                }]]),

                                keyFormatter: this.tooltipKeyFormatter(),

                                valueFormatter: function valueFormatter(d, i, entry) {
                                    var output = '-';

                                    if (!isNaN(d)) {
                                        output = '' + d;
                                    }

                                    return output;
                                }
                            }
                        }
                    }
                };
            }

            _createClass(LineChartConfig, [{
                key: 'setTranslations',
                value: function setTranslations(i18n) {
                    this.peopleUnit = i18n['people.unit'];
                }
            }, {
                key: 'tooltipKeyFormatter',
                value: function tooltipKeyFormatter() {
                    var self = this;

                    return function (d, i, entry) {

                        return self.peopleUnit;
                    };
                }
            }]);

            return LineChartConfig;
        }();
    }
})();